import React, {memo, useMemo} from 'react';
import PropTypes from 'prop-types';
import {Button, Badge, Dropdown, Menu} from 'antd';
import {useTranslation} from 'react-i18next';
import {useTableFilters} from '../../contexts/TableFiltersContext';
import {FilterOutlined, PlusOutlined} from '@ant-design/icons';
import {useResponsive} from '@/contexts/ResponsiveContext';
import FilterItem from '../FilterList/FilterItem';
import map from 'lodash/map';
import classNames from 'classnames';
import style from './index.less';
import FilterDropdown from '@/components/TableFilters/components/FilterDropdown';
import isEmpty from 'lodash/isEmpty';

const FilterButton = ({translation}) => {
  const {t} = useTranslation(translation);
  const {activeFilters, onClearAllActiveFilter, filtersValue, filters} = useTableFilters();
  const {isMobile} = useResponsive();

  const overlay = useMemo(() => (
    <Menu>
      <div className="flex w-full justify-end items-center py-2 px-4">
        {
          !isEmpty(activeFilters) &&
          <Button onClick={onClearAllActiveFilter}>{t('clearAll')}</Button>
        }
        {
          isEmpty(activeFilters) &&
          <div>{t('filterHelp.title')}</div>
        }
        <FilterDropdown translation={translation}>
          <Button className="ml-2" icon={<PlusOutlined/>}/>
        </FilterDropdown>
      </div>
      {
        !isEmpty(activeFilters) &&
        <div className={classNames('px-3 lg:max-w-4xl max-w-xs', style.container)}>
          {map(activeFilters, filter => (
            <FilterItem key={filter?.name} filter={filter} t={t}/>
          ))}
        </div>
      }
    </Menu>
  ), [activeFilters, onClearAllActiveFilter, t, translation]);

  return (<>
    {
      !isEmpty(filters) &&
      <Dropdown overlay={overlay} trigger={['click']} placement="bottomRight">
        <Badge count={filtersValue?.length} overflowCount={9}>
          <Button icon={<FilterOutlined/>}>{!isMobile && t('filters')}</Button>
        </Badge>
      </Dropdown>
    }
  </>);
};

FilterButton.propTypes = {
  translation: PropTypes.string,
};

export default memo(FilterButton);
